import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { StickyContainer } from 'react-sticky';
import { Link } from '@zola/zola-ui/src/components/Link';

import { StoreFooter } from '../../components/common/footer';
import { requestKittedProductByKey } from '../../actions/ProductActions';
import { fetchRelatedProducts } from '../../actions/ProductDetailPageActions';
import Header from '../ProductDetailPage/Header';
import UnifiedNavV2 from '../../components/common/header/UnifiedNavV2';
import { BreadCrumbSkeleton, BreadCrumbs } from '../ProductDetailPage/BreadCrumb';
import ProductsCarousel from '../ProductDetailPage/ProductsCarousel';
import ProductDetailRow from '../ProductDetailPage/ProductDetailRow';
import KitProductOverview from './KitProductOverview';
import ImageCarousel from '../ProductDetailPage/ImageCarousel';
import usePDPActiveNavItems from '../../hooks/usePDPActiveNavItems';

import '../ProductDetailPage/ProductDetailPage.less';
import './KitProductDetailPage.less';

const ImageBreadCrumb = (props) => {
  const { productData } = props;
  if (!productData) return null;
  const brandName = productData.brand.name;
  const brandKey = productData.brand.key;
  const collectionName = productData.name;
  return (
    <div className="carousel-breadcrumb_container">
      <BreadCrumbs crumbKey={productData.key} productData={productData} />
      <div className="brand-product-names-mobile">
        <Link href={`/shop/brand/${brandKey}`} className="brand-name">
          {brandName}
        </Link>
        <h3 className="product-name">{collectionName}</h3>
      </div>
      {productData && (
        <ImageCarousel
          productData={{ display_name: collectionName }}
          activeProductLook={productData}
        />
      )}
    </div>
  );
};

const KitProductDetailPage = (props) => {
  const { match, history } = props;
  const { productKey } = match.params;
  const [productData, setProductData] = useState();
  const [brandProducts, setBrandProducts] = useState([]);
  const [kittedProducts, setKittedProducts] = useState([]);
  const [collectionEventData, setCollectionEventData] = useState();
  const dispatch = useDispatch();
  const userContext = useSelector((state) => state.user.userContext);
  const { activePrimaryNav, activeSecondaryNavKey } = usePDPActiveNavItems(productData);

  useEffect(() => {
    dispatch(requestKittedProductByKey(productKey))
      .then((res) => {
        setProductData(res.payload);
        setKittedProducts(res.payload.product_views);
        const { key, name } = res.payload;
        setCollectionEventData({ collection_key: key, collection_name: name });
      })
      .catch(() => {
        // window.location.href = '/not-found';
      });
  }, []);

  useEffect(() => {
    if (productData) {
      const relatedOptions = {
        productId: productData.product_views[0].id,
      };
      dispatch(fetchRelatedProducts(relatedOptions)).then((res) => {
        setBrandProducts(res.payload.featured_products);
      });
    }
  }, [productData]);

  const firstImage =
    productData &&
    productData.images &&
    productData.images.length &&
    productData.images[0].aspect_ratios['1x1'].full;
  const productBrand = productData && productData.brand && productData.brand.name;
  return (
    <>
      <StickyContainer>
        {productData && (
          <Header
            isKit
            productBrand={productBrand}
            productKey={productKey}
            productTitle={productData.name}
            productDescription={productData.description}
            productImage={firstImage}
          />
        )}
        <UnifiedNavV2
          showPromo
          activePrimaryLink={activePrimaryNav}
          activeSecondaryLink={activeSecondaryNavKey}
        />
        <BreadCrumbSkeleton type="desktop" />
        <BreadCrumbSkeleton type="tablet" />
        <div className="product-detail-parent">
          <div className="product-detail-page_container">
            <ImageBreadCrumb productData={productData} />
            <KitProductOverview productData={productData} />
          </div>
          {kittedProducts.length > 0 && (
            <div className="also-need-products_container">
              {kittedProducts.map((product, i) => (
                <ProductDetailRow
                  key={i}
                  position={i}
                  location="KIT"
                  section="KIT"
                  userContext={userContext}
                  dispatch={dispatch}
                  productData={product}
                  history={history}
                  collectionEventData={collectionEventData}
                />
              ))}
            </div>
          )}
          {brandProducts.length > 0 && (
            <ProductsCarousel
              productData={productData}
              products={brandProducts}
              type="brand-related"
              location="KIT"
              section="BRAND"
            />
          )}
        </div>
        <StoreFooter isWebStore />
      </StickyContainer>
    </>
  );
};

ImageBreadCrumb.propTypes = {
  productData: PropTypes.shape({
    brand: PropTypes.shape({
      key: PropTypes.string,
      name: PropTypes.string,
    }),
    name: PropTypes.string,
    key: PropTypes.string,
  }),
};

KitProductDetailPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      productKey: PropTypes.string,
    }),
  }),
  history: PropTypes.shape([]),
};

export default KitProductDetailPage;
